module.exports = __webpack_public_path__ + "img/erlend-simensen-p.49170c0b.jpg";